import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/fontawesome-free-solid';

class ModalWindow extends Component {

    constructor(prop) {
        super(prop);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            isAospBrowser: prop.isAospBrowser,
            isLocalStorage: prop.isLocalStorage
        };
    }

    handleClose() {
        this.setState({
            isAospBrowser: false,
        });
    }

    render() {
        return (
            <div>
                <Modal show={this.state.isAospBrowser} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title><FontAwesomeIcon size='1x' icon={faExclamationCircle} /> Caution</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>For browsers other than Chrome, it may not be displayed.</h4>
                        <h4>Please reopen with Chrome browser.</h4>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>OK</Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={!this.state.isLocalStorage}>
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon size='1x' icon={faExclamationCircle} /> Caution</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>Local storage is not available.</h4>
                        <h4>Please enable local storage and access again.</h4>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalWindow;



// WEBPACK FOOTER //
// ./src/js/Modal.js